const Musteri = resolve => {
    require.ensure(['../views/apps/musteri/Musteri'], () => {
        resolve(require('../views/apps/musteri/Musteri'))
    })
};
const MusteriDetay = resolve => {
    require.ensure(['../views/apps/musteri/MusteriDetay'], () => {
        resolve(require('../views/apps/musteri/MusteriDetay'))
    })
};

import Vue from 'vue'
Vue.component('MusteriDetay', MusteriDetay);
import layouts from '../layout'

export default {
    path: '/musteri',
    name: 'musteri',
    component: Musteri,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'musteridetay',
            component: MusteriDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
